import React from "react";
import Particle from "../Particles/Particle";
import { Link } from "react-router-dom";
const HeroSection = () => {
  return (
    <>
      <div className="dg__slider__area slider--3"
      
      >
        <div
          className="slide d-flex align__center poss--relative"
          style={{
            background:
              " rgb(234,28,101) linear-gradient(150deg, rgba(234,28,101,1) 12%, rgba(183,18,77,1) 34%)",
          }}
        >
          <div className="container">
            <div className="row herosection-row">
              <div className="col-lg-8 col-xl-7 col-md-12 col-sm-12 col-12 d-flex align-items-center">
                <div className="contentbox">
                  <div className="slide__inner">
                    <h1>Galata Anket - Earn With Survey</h1>
                    <p
                      style={{
                        color: "white",
                      }}
                    >
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Recusandae aliquam vitae, corporis incidunt sapiente
                      pariatur dicta autem quisquam? Inventore praesentium
                      obcaecati temporibus porro sint, repellendus mollitia
                      quisquam nihil. Quos, ipsam.
                    </p>
                    <Link
                      className="slide__btn dg__btn btn--white btn--theme"
                      to={process.env.PUBLIC_URL + "/login-register"}
                    >
                      Join Us
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 herosection-img">
                <div className="dg__secure__thumb">
                  <img
                    // src={process.env.PUBLIC_URL + "/images/home/coin2.png"}
                    src={"https://images.pexels.com/photos/669619/pexels-photo-669619.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"}
                    width={500}

                    alt="Survey"
                  />
                </div>
              </div>
            </div>
          </div>
          {/* particle */}
          <Particle />
        </div>
      </div>
    </>
  );
};

export default HeroSection;
